import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from "react-hook-form";

type AutocompleteFreeSoloWithControlProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
  options: string[];
  onChange?: (value: string) => void;
};

export const AutocompleteFreeSoloWithControl = <T extends FieldValues>({
  control,
  name,
  label,
  options,
  onChange,
}: AutocompleteFreeSoloWithControlProps<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Autocomplete<string, false, false, true>
          {...field}
          onChange={(_, value) => {
            field.onChange(value ?? "");
            if (onChange) onChange(value ?? "");
          }}
          id={`${name}-autocomplete`}
          freeSolo
          options={options}
          renderInput={(params) => (
            <TextField
              {...params}
              onChange={(event) => {
                field.onChange(event.target.value);
                if (onChange) onChange(event.target.value);
              }}
              label={label}
            />
          )}
        />
      )}
    />
  );
};
